import React from 'react';
import classnames from 'classnames';

import styles from './icon-button.css';
import Colors from '../colors';

interface IconButtonProps {
  /** One of the icons specified above as a JSX Element */
  children: JSX.Element;
  /** Callback when icon is clicked */
  onClick: () => void;
  /** Color of the icon. See Colors for more information */
  color?: Colors;
  /** Size of the icon */
  size?: string;
  /** Adds additional classes to the component. */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
  /** Provides accesibility label */
  'aria-label'?: string;
}

/**
 * Button that takes in Icon component and adds styling to it
 *
 * @param {IconButtonProps} param
 *
 * @returns JSX.ELEMENT
 */
export const IconButton = ({
  children,
  className,
  onClick,
  'data-testid': dataTestId,
  'aria-label': ariaLabel,
  size = '16px',
  color = Colors.Silver
}: IconButtonProps) => {
  const iconButtonClasses = classnames(className, styles.iconButton);
  const iconClasses = classnames(styles.icon, styles[color]);

  return (
    <button
      type="button"
      onClick={onClick}
      className={iconButtonClasses}
      data-testid={dataTestId}
      aria-label={ariaLabel}
    >
      <div
        className={iconClasses}
        style={{
          width: size,
          height: size,
          lineHeight: size
        }}
      >
        {children}
      </div>
    </button>
  );
};

export default IconButton;
